import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/map_1.png'
import _imports_1 from '../assets/image/map_2.png'
import _imports_2 from '../assets/image/map_3.png'
import _imports_3 from '../assets/image/map_4.png'
import _imports_4 from '../assets/image/map_7.png'
import _imports_5 from '../assets/image/map_6.png'
import _imports_6 from '../assets/image/map_5.png'
import _imports_7 from '../assets/image/map_locname.png'
import _imports_8 from '../assets/image/map_panda_head.png'
import _imports_9 from '../assets/image/map_yun_left.png'
import _imports_10 from '../assets/image/map_yun_right.png'
import _imports_11 from '../assets/image/map_dg.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7ae92f8f")

_pushScopeId("data-v-7ae92f8f")
const _hoisted_1 = { class: "map" }
const _hoisted_2 = { class: "map-item" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "name",
  src: _imports_7,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "dialog" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("img", {
        src: _imports_0,
        alt: "",
        class: _ctx.step === 1 ? 'hover' : '',
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 1]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_1,
        alt: "",
        class: _ctx.step === 2 ? 'hover' : '',
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 2]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_2,
        alt: "",
        class: _ctx.step === 3 ? 'hover' : '',
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 3]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_3,
        alt: "",
        class: _ctx.step === 4 ? 'hover' : '',
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 4]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_4,
        alt: "",
        class: _ctx.step === 5 ? 'hover' : '',
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 5]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_5,
        alt: "",
        class: _ctx.step === 6 ? 'hover' : '',
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 6]
      ]),
      _withDirectives(_createVNode("img", {
        src: _imports_6,
        alt: "",
        class: _ctx.step === 7 ? 'hover' : '',
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, null, 2), [
        [_vShow, _ctx.step === 7]
      ])
    ]),
    _hoisted_3,
    _createVNode("img", {
      class: "head",
      src: _imports_8,
      alt: "",
      style: `left: ${ _ctx.pandnPoint[_ctx.step][0] }vw; top: ${ _ctx.pandnPoint[_ctx.step][1] }vh;`,
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
    }, null, 4),
    _createVNode("img", {
      class: ["left", _ctx.isMap ? 'left-yun' : ''],
      src: _imports_9,
      alt: ""
    }, null, 2),
    _createVNode("img", {
      class: ["right", _ctx.isMap ? 'right-yun' : ''],
      src: _imports_10,
      alt: ""
    }, null, 2),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("img", {
        src: _imports_11,
        alt: "",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleStart && _ctx.handleStart(...args)))
      })
    ], 512), [
      [_vShow, !_ctx.isMap]
    ])
  ]))
})